function createEmptyOs () {
  return {
    ordemServico: {
      subProcessos: [],
      processos: []
    },
    listaProcessosAuxiliar: [],
    processos: []
  }
}

function createEmptySubProcessos () {
  return [
    {
      usuario: {
        id: ''
      },
      funcao: 'VISTORIADOR',
      perfilAnalista: {
        codigo: ''
      }
    },
    {
      usuario: {
        id: ''
      },
      funcao: 'FISCALIZADOR',
      perfilAnalista: {
        codigo: ''
      }
    },
    {
      usuario: {
        id: ''
      },
      funcao: 'GEOMENSOR',
      perfilAnalista: {
        codigo: ''
      }
    },
    {
      usuario: {
        id: ''
      },
      funcao: 'LEVANTAMENTO_SOCIO_ECONOMICO',
      perfilAnalista: {
        codigo: ''
      }
    },
    {
      usuario: {
        id: ''
      },
      funcao: 'OUTROS',
      perfilAnalista: {
        codigo: ''
      }
    },
    {
      usuario: {
        id: ''
      },
      funcao: 'ADMINISTRATIVO',
      perfilAnalista: {
        codigo: ''
      }
    }
  ]
}

const state = {
  emptyProcesso: createEmptyOs,
  createEmptySubProcessos
}

export default {
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/empty.js